import State from './State.js';
import Deck from './Deck.js';

export default class StateShuffleCut extends State {
    constructor(context) {
        super(context);  //this.context = type of 'Cribbage'
        this.name = 'shuffle';
    }
    setup() {


        this.context.playerTurn = this.context.dealer === "player1" ? "player2" : "player1";

        this.createMessage();
    }
    action(command, value, player) {
        switch (command) {
            case "play": return this.cut(value, player); break;
            case "endCut": return this.endCut(player); break;
            default: this.unknownCommand(command, value, player);
        }
        this.createMessage();
    }
    getActions(player) {
        let actions = [];

        let pileDeck = this.context.getPile("deck");
        if (pileDeck.length > 0) {
            actions.push({ command: "endCut" });
        } else {
            let pileCut = this.context.getPile("cut");
            if (pileCut.length > 0 && player !== this.context.dealer) {
                let pileCut = this.context.getPile("cut");
                for (var i = 0; i < pileCut.length; i++) {
                    let card = pileCut[i];
                    actions.push({ command: "play", value: card.id, player: player });
                }
            }
        }


        return actions;
    }
    createMessage() {

        let dealer = this.context.dealer;
        let messageNonDealer = "Select a card to cut the shuffle";

        if (dealer == "player1") {
            this.context.sendEvent("message", messageNonDealer, "player2");
            this.context.messagePlayer1 = "";
            this.context.messagePlayer2 = messageNonDealer;
        } else {
            this.context.sendEvent("message", messageNonDealer, "player1");
            this.context.messagePlayer1 = messageNonDealer;
            this.context.messagePlayer2 = "";
        }


    }
    cut(cardId, player) {

        let card = this.context.getCard(cardId);

        if (!card) {
            this.invalidMove("Not a valid card", card);
            return;
        }
        if (player !== this.context.playerTurn) {
            this.invalidMove("It is not your turn.", player);
            return;
        }
        if (!player) {
            this.invalidMove("Not a valid player", player);
            return;
        }
       



        //if no card found then just end
        if (!card) return;

        //if already cut, then finish the cut
        let pileDeck = this.context.getPile("deck");
        if (pileDeck.length > 0) {
            this.endCut();
            return true;
        }

        
        if (card.pile !== "cut") {
            this.invalidMove("Must pull a card from the 'cut' pile", player);
            return;
        }

        //cut cards into draw pile
        let pileCut = this.context.getPile("cut");
        let drawPileZ = 0;
        for (var i = 0; i < pileCut.length; i++) {
            let cardC = pileCut[i];
            if (card.pilez <= cardC.pilez) {
                // this.context.addToPile(cardC, "deck", player);
                cardC.pile = "deck";
                cardC.pilez = drawPileZ;
                cardC.showfront = true;
                drawPileZ += 1;
            }
        }
        this.context.sendEvent("cardMoved");




        return true;
    }
    endCut() {

       
        let pileCut = this.context.getPile("cut");
        
        //continue if finished
        if (pileCut.length === 0) {
            //call setup crib state
            this.context.setState("crib");
            return true;
        }

        //cut the rest of the cards into draw pile
        for (var i = 0; i < pileCut.length; i++) {
            let cardC = pileCut[i];
            this.context.addToPile(cardC, "deck", null);
        }


        return true;
    }

    //note: move invalidMove and unknownCommand to context? so no events are called from state?
    invalidMove(message, player) {
        this.context.sendEvent("invalidMove", message, player);
    }
    unknownCommand(command, value, player) {
        this.context.unknownCommand(command, null, player);
    }

}